import {Component, tag} from 'doz'

@tag('player-html')
export default class extends Component {

    template(h) {
        return h`
            <div d-show="${!!this.PLAYER_CONFIG.playerHtml}"> 
                ${this.PLAYER_CONFIG.playerHtml}
            </div>
        `
    }

}
